import React from 'react';
import { Price } from '@aperza/ui';
const ShippingPrice = (props) => {
    return (
    // convert the shippingPrice to string so that we don't get 'ASK' for 0 values
    React.createElement(Price, { currency: 'JPY', price: '' + props.totalShippingPrice, openPrice: false }));
};
export default ShippingPrice;
